// File: src/pages/candidate/JobListPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../../css/HomePage.css'; // Tái sử dụng CSS chung

// --- ICONS ---
const IconSearch = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;
const IconMapPin = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const IconBriefcase = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const IconMoney = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>;

export default function JobListPage() {
    const navigate = useNavigate();
    const locationObj = useLocation();

    const [allJobs, setAllJobs] = useState([]);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [loading, setLoading] = useState(true);

    const [keyword, setKeyword] = useState('');
    const [location, setLocation] = useState('');
    

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // 1. Fetch Jobs
                const jobsRes = await fetch(`${apiBaseUrl}/api/jobs`);
                if (jobsRes.ok) {
                    const rawData = await jobsRes.json();
                    
                    // ✅ BƯỚC 1: Map dữ liệu & Xác định HOT (Enterprise)
                    const jobData = Array.isArray(rawData) ? rawData.map(job => {
                        // Check gói Enterprise từ data company (nếu backend có trả về populate)
                        const isEnterprise = job.companyId?.subscription?.plan === 'premium';
                        
                        // Logic xác định HOT: Là Enterprise HOẶC lương cao (fallback)
                        const isHot = isEnterprise || (job.salary && (job.salary.includes('triệu') || job.salary.includes('$'))) || false;

                        return {
                            ...job,
                            title: job.title || 'Chưa cập nhật',
                            companyName: job.companyName || job.companyId?.profile?.companyName || 'Công ty ẩn danh',
                            salary: job.salary || 'Thương lượng',
                            companyLogo: job.companyId?.profile?.logo || job.logo, // Lấy logo cty
                            isHot: isHot 
                        };
                    }) : [];

                    // ✅ BƯỚC 2: Lọc & Sắp xếp (Đưa HOT lên đầu)
                    const activeJobs = jobData
                        .filter(j => j.status === 'Đang tuyển' || j.status === 'PUBLISHED')
                        .sort((a, b) => {
                            // Ưu tiên 1: Job Hot lên đầu
                            if (b.isHot !== a.isHot) return b.isHot ? 1 : -1;
                            // Ưu tiên 2: Mới nhất lên đầu
                            return new Date(b.createdAt) - new Date(a.createdAt);
                        });
                    
                    setAllJobs(activeJobs);
                    setFilteredJobs(activeJobs);
                }

                // 2. Fetch Provinces
                const provRes = await fetch('https://provinces.open-api.vn/api/?depth=1');
                if (provRes.ok) {
                    const provData = await provRes.json();
                    setProvinces(provData);
                }

            } catch (error) { 
                console.error("Lỗi tải data:", error); 
            } finally { 
                setLoading(false); 
            }
        };
        fetchInitialData();
    }, [apiBaseUrl]);

    useEffect(() => {
        const params = new URLSearchParams(locationObj.search);
        const urlKeyword = params.get('keyword') || '';
        const urlLocation = params.get('location') || '';

        setKeyword(urlKeyword);
        setLocation(urlLocation);

        if (allJobs.length > 0) {
            const results = allJobs.filter(job => {
                const matchKeyword = urlKeyword ? (
                    job.title.toLowerCase().includes(urlKeyword.toLowerCase()) ||
                    job.companyName.toLowerCase().includes(urlKeyword.toLowerCase())
                ) : true;

                const matchLocation = urlLocation ? (() => {
                    const cleanLoc = urlLocation.replace('Thành phố ', '').replace('Tỉnh ', '').trim().toLowerCase();
                    const jobLoc = (job.location || '').toLowerCase();
                    return jobLoc.includes(cleanLoc);
                })() : true;

                return matchKeyword && matchLocation;
            });
            setFilteredJobs(results);
        }
    }, [locationObj.search, allJobs]);

    const handleSearch = (e) => {
        e.preventDefault();
        navigate(`/jobs?keyword=${encodeURIComponent(keyword)}&location=${encodeURIComponent(location)}`);
    };

    return (
        <div className="homepage-wrapper">
            <main className="bbb">

                {/* ✅ 1. HEADER ĐỒNG BỘ (Gradient + Floating Box) */}
                <div className="search-header-container">
                    <div className="search-bg-decoration"></div>
                    <div className="header-content">
                        <h2 className="page-title">Tìm kiếm việc làm tốt nhất</h2>
                        <p className="page-subtitle">Hàng ngàn cơ hội nghề nghiệp đang chờ đón bạn</p>

                        <div className="search-box-wrapper">
                            <div className="search-input-group flex-grow">
                                <span className="search-icon"><IconSearch /></span>
                                <input
                                    type="text"
                                    placeholder="Vị trí tuyển dụng, tên công ty..."
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                />
                            </div>

                            <div className="divider"></div>

                            <div className="search-input-group location-select">
                                <span className="search-icon"><IconMapPin /></span>
                                <select
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                >
                                    <option value="">Tất cả địa điểm</option>
                                    {provinces.map((prov) => (
                                        <option key={prov.code} value={prov.name}>
                                            {prov.name.replace("Thành phố ", "").replace("Tỉnh ", "")}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button className="btn-search-submit" onClick={handleSearch}>
                                Tìm kiếm
                            </button>
                        </div>
                        
                    </div>
                </div>

                {/* ✅ 2. LIST KẾT QUẢ DẠNG GRID 3 CỘT */}
                <div className="content-container">
                    <div className="results-meta">
                        Tìm thấy <span style={{ fontWeight: 700, color: '#2563EB' }}>{filteredJobs.length}</span> việc làm
                        {(keyword || location) && <span> phù hợp</span>}
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: 60, color: '#6B7280' }}>
                            <span className="material-symbols-outlined spin">sync</span> Đang tải dữ liệu...
                        </div>
                    ) : filteredJobs.length > 0 ? (

                        // GRID CONTAINER
                        <div className="job-grid-3">
                            {filteredJobs.map(job => (
                                <div key={job._id} className="job-card-grid" onClick={() => navigate(`/jobs/${job._id}`)}>
                                    {job.isHot && (
                            <div className="absolute top-2 right-2">
                                <span className="inline-flex items-center gap-1 bg-red-100 text-red-600 text-[10px] font-bold px-2 py-1 rounded-md border border-red-200 shadow-sm">
                                    HOT <span className="material-symbols-outlined text-[12px]">bolt</span>
                                </span>
                            </div>
                        )}

                                    {/* Header Card */}
                                    <div className="card-top">
                                        <div className="c-logo-grid" style={{ background: '#F3F4F6', color: '#374151' }}>
                                            {job.companyName ? job.companyName.charAt(0).toUpperCase() : 'C'}
                                        </div>
                                        
                                    </div>

                                    {/* Body Card */}
                                    <div className="card-body">
                                        <h3 className="job-title-grid" title={job.title}>{job.title}</h3>
                                        <p className="company-name-grid">{job.companyName}</p>

                                        <div className="tags-grid">
                                            <span className="tag"><IconMapPin /> {job.location}</span>
                                            <span className="tag"><IconBriefcase /> {job.type}</span>{job.salary && <span className="salary-badge">{job.salary}</span>}
                                        </div>
                                    </div>

                                    {/* Footer Card */}
                                    <div className="card-bottom">
                                        <button className="btn-view-detail">Xem chi tiết</button>
                                    </div>
                                </div>
                            ))}
                        </div>

                    ) : (
                        <div className="no-results-box">
                            <div style={{ fontSize: 40, marginBottom: 16 }}>🔍</div>
                            <p style={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>Không tìm thấy công việc nào</p>
                            <p style={{ color: '#6B7280', marginTop: 4 }}>Thử thay đổi từ khóa hoặc bộ lọc địa điểm</p>
                            <button onClick={() => { setKeyword(''); setLocation(''); navigate('/jobs'); }}>
                                Xóa bộ lọc
                            </button>
                        </div>
                    )}
                </div>
            </main>

            {/* ✅ CSS RIÊNG CHO TRANG NÀY */}
            <style>{`
                .homepage-wrapper { background: #F9FAFB; min-height: 100vh; }
                .bbb {
    
    /* Tách xa Navbar hơn */
    padding-bottom: 80px;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    flex: 1;
    /* Đẩy footer xuống dưới cùng */
}
                
                /* --- HEADER STYLES (Đồng bộ với Company/Test) --- */
                .search-header-container {
                    background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
                    padding: 110px 24px 80px; text-align: center; position: relative; margin-bottom: 40px;
                    border-radius: 0 0 40px 40px; box-shadow: 0 4px 20px -5px rgba(37, 99, 235, 0.1);
                }
                .page-title { font-size: 28px; font-weight: 800; color: #1E40AF; margin-bottom: 8px; }
                .page-subtitle { color: #4B5563; margin-bottom: 32px; font-size: 16px; }

                /* Search Box */
                .search-box-wrapper {
                    background: white; max-width: 800px; margin: 0 auto; border-radius: 16px; padding: 8px;
                    display: flex; align-items: center; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); border: 1px solid #E5E7EB;
                }
                .search-input-group { display: flex; align-items: center; padding: 0 16px; position: relative; }
                .flex-grow { flex: 1; }
                .location-select { width: 200px; }
                .search-icon { color: #9CA3AF; margin-right: 12px; display: flex; }
                .search-box-wrapper input, .search-box-wrapper select {
                    width: 100%; border: none; outline: none; font-size: 15px; color: #111827; padding: 12px 0; background: transparent;
                }
                .divider { width: 1px; height: 32px; background: #E5E7EB; margin: 0 8px; }
                .btn-search-submit {
                    background: #2563EB; color: white; border: none; padding: 12px 24px; border-radius: 10px;
                    font-weight: 600; cursor: pointer; transition: all 0.2s; min-width: 100px;
                }
                .btn-search-submit:hover { background: #1D4ED8; transform: translateY(-1px); }

                /* --- CONTENT STYLES --- */
                .content-container { max-width: 1200px; margin: 0 auto; padding: 0 24px 60px; }
                .results-meta { margin-bottom: 24px; color: #6B7280; font-size: 14px; }

                /* --- GRID SYSTEM (3 CỘT) --- */
                .job-grid-3 {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr); /* 3 cột đều nhau */
                    gap: 24px; /* Khoảng cách giữa các thẻ */
                }

                /* --- JOB CARD STYLES (Vertical Layout) --- */
                .job-card-grid {
                    background: white; border-radius: 16px; padding: 20px;
                    border: 1px solid #E5E7EB; transition: all 0.2s; cursor: pointer;
                    display: flex; flex-direction: column;
                    position: relative;
                }
                .job-card-grid:hover {
                    border-color: #BFDBFE; box-shadow: 0 12px 24px -8px rgba(37, 99, 235, 0.15); transform: translateY(-4px);
                }

                /* Card Top */
                .card-top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
                .c-logo-grid {
                    width: 56px; height: 56px; border-radius: 12px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 1.5rem; font-weight: 700; border: 1px solid #F3F4F6;
                }
                .salary-badge {
                    font-size: 12px; font-weight: 600; color: #059669;
                    background: #ECFDF5; padding: 4px 10px; border-radius: 20px;
                }

                /* Card Body */
                .card-body { flex: 1; display: flex; flex-direction: column; }
                .job-title-grid {
                    font-size: 18px; font-weight: 700; color: #111827; margin: 0 0 6px;
                    line-height: 1.4;
                    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
                }
                .company-name-grid { font-size: 14px; color: #4B5563; margin-bottom: 16px; }
                
                .tags-grid { display: flex; flex-wrap: wrap; gap: 8px; margin-top: auto; }
                .tags-grid .tag {
                    font-size: 12px; color: #6B7280; background: #F9FAFB;
                    padding: 4px 8px; border-radius: 6px; display: flex; align-items: center; gap: 4px;
                }

                /* Card Footer */
                .card-bottom { margin-top: 20px; border-top: 1px solid #F3F4F6; padding-top: 16px; }
                .btn-view-detail {
                    width: 100%; padding: 10px; border-radius: 8px;
                    background: #EFF6FF; color: #2563EB; font-weight: 600; border: none;
                    cursor: pointer; transition: all 0.2s;
                }
                .job-card-grid:hover .btn-view-detail { background: #2563EB; color: white; }

                /* No Results */
                .no-results-box {
                    grid-column: 1 / -1; text-align: center; padding: 60px; background: white; border-radius: 16px; border: 1px dashed #D1D5DB;
                }
                .no-results-box button {
                    margin-top: 16px; padding: 8px 16px; background: white; border: 1px solid #D1D5DB; 
                    border-radius: 6px; cursor: pointer; font-weight: 500;
                }
                .spin { animation: spin 1s linear infinite; vertical-align: middle; margin-right: 8px; }
                @keyframes spin { 100% { transform: rotate(360deg); } }

                /* RESPONSIVE */
                @media (max-width: 1024px) { .job-grid-3 { grid-template-columns: repeat(2, 1fr); } }
                @media (max-width: 768px) {
                    .search-box-wrapper { flex-direction: column; gap: 8px; padding: 16px; }
                    .search-input-group, .location-select, .btn-search-submit { width: 100%; }
                    .divider { display: none; }
                    .job-grid-3 { grid-template-columns: 1fr; }
                }
            `}</style>
        </div>
    );
}